import * as THREE from 'three'
import { useState, useEffect } from 'react'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { useGLTF } from '@react-three/drei'
// TODO: use draco loader for using compressed gltf files
// import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { preload_assets } from './data/PortfolioData'

export default function LoadingAssets({ onLoadingScreenProgressUpdate, onAssetsLoaded }) {
    const [gltfLoaded, setGltfLoaded] = useState(false)
    const [gltfProgress, setGltfProgress] = useState(0)

    useEffect(() => {
        const glbUrls = Object.keys(preload_assets.glbUrls) || []
        const totalGltfCount = glbUrls.length
        const textureUrls = Object.keys(preload_assets.textures) || []
        const fontUrls = Object.keys(preload_assets.fonts) || []

        // console.log(`Starting to load ${totalGltfCount} GLTF models:`, glbUrls)

        let loadedCount = 0
        const loadGLB = (url) => {
            return new Promise((resolve) => {
                const loader = new GLTFLoader()
                loader.load(
                    url,
                    (gltf) => {
                        loadedCount++
                        const progress = (loadedCount / totalGltfCount) * 100
                        console.log(`GLTF ${loadedCount}/${totalGltfCount} loaded: ${url} (${progress}%)`)
                        setGltfProgress(progress)
                        if (loadedCount === totalGltfCount) {
                            // console.log('All GLTF models loaded!')
                            setGltfLoaded(true)
                        }
                        useGLTF.preload(url)
                        resolve()
                    },
                    (xhr) => {
                        const progress = (xhr.loaded / xhr.total) * 100
                        // console.log(`Loading GLTF ${url}: ${progress}%`)
                    },
                    (error) => {
                        // console.error(`Failed to load GLB: ${url}`, error)
                        loadedCount++
                        const progress = (loadedCount / totalGltfCount) * 100
                        // console.log(`GLTF ${loadedCount}/${totalGltfCount} failed: ${url} (${progress}%)`)
                        setGltfProgress(progress)
                        if (loadedCount === totalGltfCount) {
                            // console.log('All GLTF models processed (some may have failed)')
                            setGltfLoaded(true)
                        }
                        resolve()
                    }
                )
            })
        }

        const loadTexture = (url) => {
            return new Promise((resolve) => {
                // console.log(`Loading texture: ${url}`)
                const textureLoader = new THREE.TextureLoader()
                const texture = textureLoader.load(url)
                // console.log(`Texture loaded: ${url}`)
                resolve()
            })
        }

        const loadFont = (url) => {
            return new Promise((resolve) => {
                // console.log(`Loading font: ${url}`)
                const fontLoader = new FontLoader()
                const font = fontLoader.parse(url)
                // console.log(`Font loaded: ${url}`)
                resolve()
            })
        }

        const loadAssets = async () => {
            for (const urlKey of glbUrls) {
                await loadGLB(preload_assets.glbUrls[urlKey])
            }
            for (const urlKey of textureUrls) {
                await loadTexture(preload_assets.textures[urlKey])
            }
            for (const urlKey of fontUrls) {
                await loadFont(preload_assets.fonts[urlKey])
            }
        }
        loadAssets()
    }, [])

    // Calculate and update total progress
    useEffect(() => {
        const totalProgress = Math.floor(gltfProgress / 1)
        // should be /2 but since videos not working showing the progress is better to divide by 1 and show 100%
        // const totalProgress = Math.floor((gltfProgress + videoTexturesProgress) / 2)
        // console.log(`Total progress: ${totalProgress}% (GLTF: ${gltfProgress}%, Videos: ${videoTexturesProgress}%, Loaded videos: ${loadedVideosCount}/${totalVideos})`)

        // Determine loading text based on what's currently loading
        let loadingText = 'Loading videos...'
        if (gltfProgress < 100) {
            loadingText = 'Loading 3D models...'
        } else if (totalProgress === 100) {
            loadingText = 'Almost there...'
        }

        onLoadingScreenProgressUpdate(totalProgress, loadingText)
    }, [gltfProgress, onLoadingScreenProgressUpdate])

    useEffect(() => {
        if (gltfLoaded) {
            console.log('Loading complete! All assets loaded.')
            onAssetsLoaded()
        }
    }, [gltfLoaded, onAssetsLoaded])

    return (
        <>
        </>
    )
}
